export const VALUE = "value";
export const ERROR = "error";
export const REQUIRED_FIELD_ERROR = "ERROR_EMPTY_FIELD";

function is_bool(value) {
  return typeof value === "boolean";
}

/**
 * Determines a value if it's an object
 *
 * @param {object} value
 */
export function is_object(value) {
  return typeof value === "object" && value !== null;
}

/**
 *
 * @param {string} value
 * @param {boolean} isRequired
 */
export function is_required(value, isRequired) {
  if (!value && isRequired) return REQUIRED_FIELD_ERROR;
  return "";
}

export function get_prop_values(stateSchema, prop) {
  return Object.keys(stateSchema).reduce((field, key) => {
    field[key] = is_bool(prop) ? prop : stateSchema[key][prop];
    return field;
  }, {});
}

export function getValidatorSchema() {
  const validatorSchema = {
    firstName: {
      required: true,
      validator: {
        func: (value) => /[^ ](?:(?=[\p{Script=Arabic}A-Za-z])\p{L}|\s)+$/u.test(value),  
        error: "ERROR_FIRST_NAME",
      },
    },
    secondName: {
      required: true,
      validator: {
        func: (value) => /[^ ](?:(?=[\p{Script=Arabic}A-Za-z])\p{L}|\s)+$/u.test(value),  
        error: "ERROR_FIRST_NAME",
      },
    },
    thirdName: {
      required: true,
      validator: {
        func: (value) => /[^ ](?:(?=[\p{Script=Arabic}A-Za-z])\p{L}|\s)+$/u.test(value),  
        error: "ERROR_FIRST_NAME",
      },
    },
    lastName: {
      required: true,
      validator: {
        func: (value) => /[^ ](?:(?=[\p{Script=Arabic}A-Za-z])\p{L}|\s)+$/u.test(value),  
        error: "ERROR_LAST_NAME",
      },
    },


    applicationReferenceNumber: {
      required: true,
      validator: {
        func: (value) => /^([/A-Za-z\u0621-\u064A\u0660-\u06690-9]{1,})+$/.test(value),
        error: "ERROR_USER_REFERENCE_NUMBER",
      },
    },
    notes: {
      required: false,
      validator: {
        func: (value) => {
          if (!value) return true;
          return /^[/A-Za-z\u0621-\u064AÀ-ȕ0-9(),-_., \r\n]{1,}$/.test(value);
        },
        error: "ERROR_NOTES",
      },
    },
    passportNumber: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9]{3,})+$/.test(value),
        error: "ERROR_PASSPORT_NUMBER",
      },
    },
    receiptNumber: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9]{1,})+$/.test(value),
        error: "ERROR_RECEIPT_NUMBER",
      },
    },

    occupation: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9_ ]{1,})+$/.test(value),
        error: "ERROR_OCCUPATION",
      },
    },
    visaExpiryDate: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },
    passportExpiryDate: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },
    passportIssueDate: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },
    dateOfBirth:  {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },
    
    purposeVisit: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9_ ]{1,})+$/.test(value),
        error: "ERROR_PURPOSE_VISIT",
      },
    },

    nationality : {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9]{1,})+$/.test(value),
        error: "ERROR_NAIONALITY",
      },
    },
    nationalIdNumber: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9]{1,})+$/.test(value),
        error: "ERROR_NATIONAL_ID_NUMBER",
      },
    },

    emailAddress: {
      required: true,
      validator: {
        func: (value) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}/.test(value),
        error: "ERROR_EMAIL_ADDRESS",
      },
    },
    streetName: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9 ]{3,})+$/.test(value),
        error: "ERROR_STREET_NAME",
      },
    },
    apartmentNo: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A\u0660-\u06690-9]{1,})+$/.test(value),
        error: "ERROR_APARTMENT_NO",
      },
    },
    city: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_CITY",
      },
    },
    area: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_AREA",
      },
    },
    embassyCode: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_EMBASSY",
      },
    },

    citizenName: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_EMBASSY",
      },
    },
    

    mobileNumber: {
      required: true,
      validator: {
        func: (value) => /^([0-9]{9,})+$/.test(value),
        error: "ERROR_CONTACT_NUMBER",
      },
    },
    accountEmail: {
      required: true,
      validator: {
        func: (value) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}/.test(value),
        error: "ERROR_EMAIL_ADDRESS",
      },
    },
    accountPassword: {
      required: true,
      validator: {
        func: (value) => /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8}/.test(value),
        error: "ERROR_STRONG_PASSWORD",
      },
    },
    billingFirstName: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A]{3,})+$/.test(value),
        error: "ERROR_FIRST_NAME",
      },
    },
    billingLastName: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A]{3,})+$/.test(value),
        error: "ERROR_LAST_NAME",
      },
    },
    billingCity: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A]{3,})+$/.test(value),
        error: "ERROR_CITY",
      },
    },
    billingCountry: {
      required: true,
      validator: {
        func: (value) => /^([A-Za-z\u0621-\u064A]{3,})/.test(value),
        error: "ERROR_COUNTRY",
      },
    },
    attestationNatureCode: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },
    attestationTypeCode: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_ATTESTATION_TYPE",
      },
    },

    dateSlot: {
      required: true,
      validator: {
        func: (value) => (value !== "" ? true : false),
        error: "ERROR_EMPTY_FIELD",
      },
    },
    timeSlot: {
      required: true,
      validator: {
        func: (value) =>
          value !== "" && value !== null && value !== undefined,
        error: "ERROR_EMPTY_FIELD",
      },
    },

    
    billingFullAddress: {
      required: true,
      validator: {
        func: (value) => /^[A-Za-z\u0621-\u064AÀ-ȕ0-9(),-_.,/ \r\n]{5,}$/.test(value),
        error: "ERROR_ADDRESS",
      },
    },
    goodConductShippingSelected: {
      required: false,
      validator: {
        func: () => true,
        error: "ERROR_EMPTY_FIELD",
      },
    },
    shippingDetails: {
      required: false,
      validator: {
        func: () => true,
        error: "ERROR_EMPTY_FIELD",
      },
    },
    goodConductAppointmentReference: {
      required: false,
      validator: {
        func: () => true,
        error: "ERROR_EMPTY_FIELD",
      },
    },
    internationalOrderPayload: {
      required: false,
      validator: {
        func: () => true,
        error: "ERROR_EMPTY_FIELD",
      },
    },
  };
  return validatorSchema;
}

export function getStateSchema() {
  return {
    embassyCode: { value: "", error: "" },
    paymentCode: { value: "", error: "" },
    amount: { value: 0, error: "" },
    vat: { value: 5, error: "" },
    totalAmount: { value: 0, error: "" },
    embassyNameEn: { value: "", error: "" },
    embassyNameAr: { value: "", error: "" },
    embassyLogo: { value: "", error: "" },
    embassyDescriptionAR: { value: "", error: "" },
    embassyDescriptionEN: { value: "", error: "" },
    embassyDescriptionOther: { value: "", error: "" },
    city: { value: "", error: "" },
    cityName: { value: "", error: "" },
    area: { value: "", error: "" },
    areaName: { value: "", error: "" },
    streetName: { value: "", error: "" },
    building: { value: "", error: "" },
    floor: { value: "", error: "" },
    apartmentNo: { value: "", error: "" },
    fullAddress: { value: "", error: "" },
    firstName: { value: "", error: "" },
    secondName: { value: "", error: "" },
    thirdName: { value: "", error: "" },
    
    lastName: { value: "", error: "" },
    passportNumber: { value: "", error: "" },
    mobileNumber: { value: "", error: "" },
    emailAddress: { value: "", error: "" },
    mobileDialCode: { value: "", error: "" },
    mobileISOCode: { value: "", error: "" },
    mobileCountryName: { value: "", error: "" },
    isMobileValid: { value: false, error: "" },
    isMobileVerified: { value: false, error: "" },
    referenceNumber: { value: "", error: "" },
    locale: { value: "en", error: "" },
    isBillingSame: { value: true, error: "" },
    billingFirstName: { value: "", error: "" },
    billingLastName: { value: "", error: "" },
    billingCountry: { value: "", error: "" },
    billingCity: { value: "", error: "" },

    accountEmail: { value: "", error: "" },
    accountPassword: { value: "", error: "" },
    confirmValue: { value: "", error: "" },
    confirmPassword: { value: false, error: "" },
    bookingReference: { value: "", error: "" },
    AWBNumber: { value: "", error: "" },
    paymentStatus: { value: "", error: "" },
    isLoading: { value: false, error: "" },
    loaderText: { value: "Loading... Please wait...", error: "" },
    accessToken: { value: "", error: "" },
    receiptNumber: { value: "", error: "" },
    nationalIdNumber: { value: "", error: "" },

    applicationReferenceNumber: { value: "", error: "" },
    notes: { value: "", error: "" },
    configuration: { value: { showNationalIdNumber: 0, showPassportNumber: 0, showFirstName: 0, showLastName: 0, showReferenceNumber: 0, showNotes: 0, showReceiptNumber: 0 }, error: "" },
    paymentOptions: { value: [], error: "" },
    attestationTypeCode: { value: "--", error: "" },
    attestationNatureCode: { value: "--", error: "" },
    dateSlot: { value: "", error: "" },
    timeSlot: { value: "", error: "" },
    attachedFile:               { value: [], error: "" },
    goodConductShippingSelected: { value: true, error: "" },
    shippingDetails: { value: null, error: "" },
    goodConductAppointmentReference: { value: "", error: "" },
    internationalOrderPayload: { value: null, error: "" },

  };
}



export function formatBookingData(value) {


  const {
    showNationalIdNumber,
    showPassportNumber,
    showReceiptNumber,
    showFirstName,
    showThirdName,
    showSecondName,
    showReferenceNumber,
    showLastName,
    showNotes,
    uploadDocument
  } = value.configuration;

  
  const obj = {
    embassyCode: value.embassyCode,
    serviceCode: value.serviceTypeCode,
    serviceTypeName:value.citizenName ? value.citizenName+"-"+ value.serviceTypeName: value.serviceTypeName,
    receiverAddress: {
      city: value.city,
      area: value.area,
      streetName: value.streetName,
      building: value.building,
      floor: value.floor,
      apartmentNo: value.apartmentNo,
      fullAddress: value.fullAddress
    },
    receiverContactDetails: {
      mobileNumber: value.mobileDialCode + "" + value.mobileNumber,
      emailAddress: value.emailAddress
    },
    preferredDateCollect: value.dateSlot,
    preferredTimeCollect: value.timeSlot,
    attestationData:
    {
      attestationNatureCode: value.attestationNatureCode,
      attestationNatureName: value.attestationNatureName,
      attestationTypeCode: value.attestationTypeCode,
      attestationTypeName: value.attestationTypeName,
      isAlreadyAttested: value.alreadyAttested ? true : false
    },
    pieces:value.numberOfDocument=="0"  ? "1": value.numberOfDocument.toString() ,
    specialNotes: value.SpecialNotes,
    orderExtraData:{
      "VisaExpiryDate":value.visaExpiryDate,
      "PassportExpiryDate":value.passportExpiryDate,
      "PassportNumber":value.passportNumber,
      "NationalIdNumber":value.nationalIdNumber,
      "ReceiptNumber":value.receiptNumber,
      "DateOfBirth":value.dateOfBirth,
      "Occupation":value.occupation,
      "PassportIssueDate":value.passportIssueDate,
      "Nationality":value.nationality,
      "PurposeVisit":value.purposeVisit,
      "PassportType":"عادی"
    },
    paymentRequest:
    {
      redirectUrl: process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/embassy/payment-summary?locale=" + value.locale + "&order",
      billingAddress: {
        firstName: value.isBillingSame ? value.firstName : value.billingFirstName,
        lastName: value.isBillingSame ? value.lastName : value.billingLastName,
        address: value.isBillingSame ? value.fullAddress : value.billingFullAddress,
        city: value.isBillingSame ? value.cityName : value.billingCity,
        countryName: value.isBillingSame ? "United Arab Emirates" : value.billingCountry
      }
    }
  }

  if (showFirstName) {
    obj.receiverContactDetails.firstName = value.firstName;
  }

  if (showLastName) {
    obj.receiverContactDetails.lastName = value.lastName;
  }


    obj.receiverContactDetails.thirdName = value.thirdName;
  
  
    obj.receiverContactDetails.secondName = value.secondName;
  

  if (showNotes) {
    obj.receiverContactDetails.notes = value.notes;
  }

  if (showPassportNumber) {
    obj.receiverContactDetails.passportNumber = value.passportNumber;
  }

  if (showNationalIdNumber) {
    obj.receiverContactDetails.nationalIdNumber = value.nationalIdNumber;
  }

  if (showReferenceNumber) {
    obj.receiverContactDetails.applicationReferenceNumber = value.applicationReferenceNumber;
  }
     

  if (showReceiptNumber) {
    obj.receiverContactDetails.receiptNumber = value.receiptNumber;
  }

  if (showNotes) {
    obj.receiverContactDetails.showNotes = value.showNotes;
  }
 
  obj.documentAsBase64=value.showUploadDocument==1 ? value.documentBase64 ? value.documentBase64 : '' : '';
  obj.referenceNumber=value.refnumber;
  obj.accountNumber =value.accountNumber;

 
  return obj;
}

export function formatOTPRequest(value) {
  return {
    "mobileNumber": "+" + value.mobileDialCode + "" + value.mobileNumber,
    "language": value.locale,
    "applicationCode": "EPWebSite",
    "numberOfOtpDigits": 4
  }
}

export function formatOTPVerification(value, otpValue) {
  return {
    "code": otpValue,
    "transactionId": value.otpReference
  }
}

export function getTokenRequest() {
  return "client_id=Website_Client&client_secret=7f7d2575-604d-4b6b-a3e9-76b9be19bc10&grant_type=client_credentials&scope=Embassy";
}

export function formatInitiatePaymentRequest(value, orderReference) {
  return {
    action: "SALE",
    amount: {
      currencyCode: "AED",
      value: value.totalAmount * 100
    },
    emailAddress: value.emailAddress,
    language: value.locale ? value.locale : "en",
    merchantAttributes: {
      redirectUrl: process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/embassy/payment-summary?order=" + orderReference,
      skipConfirmationPage: true,
      skip3DS: true,
      merchantOrderReference: orderReference
    },
    billingAddress: {
      firstName: value.isBillingSame ? value.firstName : value.billingFirstName,
      lastName: value.isBillingSame ? value.lastName : value.billingLastName,
      address: value.isBillingSame ? value.fullAddress : value.billingFullAddress,
      city: value.isBillingSame ? value.cityName : value.billingCity,
      countryName: value.isBillingSame ? "United Arab Emirates" : value.billingCountry
    },
    referenceNumber: orderReference
  }
}

export function getEmbassyInstructions(en_embassyDescriptions,ar_embassyDescriptions, heading, lang, specialInstruction,embassyCode) {
  
  
 
  var multipleDescriptions = [];

  switch (lang) {
    case "en":
      multipleDescriptions = en_embassyDescriptions;
      break;
    case "ar":
      multipleDescriptions = ar_embassyDescriptions;
      break;
    case "other":
      multipleDescriptions = en_embassyDescriptions;
      break;
    default:
      break;
  }


  if ( multipleDescriptions?.length>0) {
    return (
      <>
        {
          multipleDescriptions ?
            <div>
              {multipleDescriptions.map((item,i)=>{
                return <div>
                  <h4>{item.title}</h4>
                  {embassyCode === "JOR" && <p>{specialInstruction}</p>}
                  <ol>
                    
                    { item.text.split('\n').map((text, j) => {                    
                      return (text.substring(0, 1) !== "*") ? <li>{text}</li> :
                      (
                        <div className="instruction-detail">
                          <img className="instruction-warning" src="./images/warning-blue.svg" alt="payment success" />
                          {text.substring(1)}
                        </div>
                      ) 
                    })}
                  </ol>
                </div> 
              })
            }
            </div> :
            <div>
              <h4></h4>
            </div>
        }
      </>
    );
  }

}
